import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { PasswordRecoveryHeader } from '../components'
import { ResetForm } from './ResetForm'

import './index.css'

export function ResetPassword({ history, location }) {
    const recoveryTokenFromState = location?.state?.recoveryToken
    const { token: tokenFromParams } = useParams()

    const searchParams = new URLSearchParams(location?.search || '')
    const tokenFromQuery = searchParams.get('token') || searchParams.get('stateToken') || searchParams.get('recoveryToken') || searchParams.get('recovery_token')

    const recoveryToken = recoveryTokenFromState || tokenFromQuery || tokenFromParams

    useEffect(() => {
         if (location.state == null) {
            const hasToken = !!(tokenFromParams || tokenFromQuery)
            const { path, state } = hasToken
                ? { path: '/signin/reset-password', state: { recoveryToken } }
                : { path: '/login', state: {} }

            history.push(path, state)
        }
    }, [location.state, tokenFromParams, tokenFromQuery, recoveryToken, history])

    return (
        <div className="c-reset-password">
            <PasswordRecoveryHeader />
            <ResetForm recoveryToken={recoveryToken} />
        </div>
    )
}